import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class PurchaseWith3DSSample extends Component {
    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }
    
    renderDOTNET() {
        const { storeId, apiToken, expdate, amount, currency, pan, cavv, eci, mcpRateToken } = this.props;

        return (
            <pre className="sampleCode">
{`namespace Moneris
{
 using System;
 using System.Text;
 using System.Collections;
 public class TestCanadaMCPCavvPurchase
 { 
  public static void Main(string[] args)
  { 
    string store_id = "`}{this.getValue(storeId, "storeId")}{`";
    string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
    string order_id = "Test" + DateTime.Now.ToString("yyyyMMddhhmmss");
    string cust_id = "CUS887H67";
    string amount = "`}{this.getValue(amount, "amount")}{`";
    string pan = "`}{this.getValue(pan, "pan")}{`";
    string expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM
    string cavv = "${cavv}";
    string dynamic_descriptor = "123456";
    string wallet_indicator = "APP";
    string processing_country_code = "CA";
    string crypt_type = "${eci}";
    bool status_check = false;

    MCPCavvPurchase mcpCavvPurchase = new MCPCavvPurchase();
    mcpCavvPurchase.SetOrderId(order_id);
    mcpCavvPurchase.SetCustId(cust_id);
    mcpCavvPurchase.SetAmount(amount);
    mcpCavvPurchase.SetPan(pan);
    mcpCavvPurchase.SetExpDate(expdate);
    mcpCavvPurchase.SetCavv(cavv);
    mcpCavvPurchase.SetCryptType(crypt_type); //Mandatory for AMEX cards only
    mcpCavvPurchase.SetDynamicDescriptor(dynamic_descriptor);
    mcpCavvPurchase.SetThreeDSVersion("2"); //Mandatory for 3DS Version 2.0+
    mcpCavvPurchase.SetThreeDSServerTransId("e11d4985-8d25-40ed-99d6-c3803fe5e68f"); //Mandatory
    for 3DS Version 2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
    //mcpCavvPurchase.SetDsTransId("12345"); //Optional - to be used only if you are using 3rd
    party 3ds 2.0 service
    //mcpCavvPurchase.SetNetwork("Interac"); //set only for Interac e-commerce
    //mcpCavvPurchase.SetDataType("3DSecure"); //set only for Interac e-commerce
    //mcpCavvPurchase.SetWalletIndicator(wallet_indicator); //set only wallet transactions e.g.
    APPLE PAY
    //mcpCavvPurchase.SetCmId("8nAK8712sGaAkls56"); //set only for usage with Offlinx - Unique
    max 50 alphanumeric characters transaction id generated by merchant
    mcpCavvPurchase.SetCofInfo(cof);

    //MCP Fields
    mcpResPurchaseCC.SetMCPVersion("1.0");
    mcpResPurchaseCC.SetCardholderAmount("`}{this.getValue(amount, "amount")}{`");
    mcpResPurchaseCC.SetCardholderCurrencyCode("`}{this.getValue(currency, "currency")}{`");
    //mcpResPurchaseCC.SetMCPRateToken("${mcpRateToken}");

    HttpsPostRequest mpgReq = new HttpsPostRequest();

    mpgReq.SetProcCountryCode(processing_country_code);
    mpgReq.SetTestMode(true); //false or comment out this line for production transactions
    mpgReq.SetStoreId(store_id);
    mpgReq.SetApiToken(api_token);
    mpgReq.SetTransaction(mcpCavvPurchase);
    mpgReq.SetStatusCheck(status_check);
    mpgReq.Send();

   try
   { 
    Receipt receipt = mpgReq.GetReceipt();
    Console.WriteLine("CardType = " + receipt.GetCardType());
    Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
    Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
    Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
    Console.WriteLine("TransType = " + receipt.GetTransType());
    Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
    Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
    Console.WriteLine("ISO = " + receipt.GetISO());
    Console.WriteLine("BankTotals = " + receipt.GetBankTotals());
    Console.WriteLine("Message = " + receipt.GetMessage());
    Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
    Console.WriteLine("Complete = " + receipt.GetComplete());
    Console.WriteLine("TransDate = " + receipt.GetTransDate());
    Console.WriteLine("TransTime = " + receipt.GetTransTime());
    Console.WriteLine("Ticket = " + receipt.GetTicket());
    Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
    Console.WriteLine("CavvResultCode = " + receipt.GetCavvResultCode());
    Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
    Console.WriteLine("ThreeDSVersion = " + receipt.GetThreeDSVersion());
    Console.WriteLine("MerchantSettlementAmount = " + receipt.GetMerchantSettlementAmount());
    Console.WriteLine("CardholderAmount = " + receipt.GetCardholderAmount());
    Console.WriteLine("CardholderCurrencyCode = " + receipt.GetCardholderCurrencyCode());
    Console.WriteLine("MCPRate = " + receipt.GetMCPRate());
    Console.WriteLine("MCPErrorStatusCode = " + receipt.GetMCPErrorStatusCode());
    Console.WriteLine("MCPErrorMessage = " + receipt.GetMCPErrorMessage());
    Console.WriteLine("HostId = " + receipt.GetHostId());
    Console.ReadLine();
   } 
   catch (Exception e)
   { 
    Console.WriteLine(e);
   }
  }
 }
}
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken, expdate, amount, currency, mcpRateToken, eci, cavv } = this.props;

        return (
            <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaMCPCavvPurchase
{ 
 public static void main(String[] args)
 { 
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  java.util.Date createDate = new java.util.Date();
  String order_id = "Test"+createDate.getTime();
  String cust_id = "CUS887H67";
  String amount = "`}{this.getValue(amount, "amount")}{`";
  String pan = "4740611374762707";
  String expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM
  String cavv = "${cavv}";
  String dynamic_descriptor = "123456";
  String processing_country_code = "CA";
  String crypt_type = "${eci}";
  boolean status_check = false;
  
  MCPCavvPurchase mcpCavvPurchase = new MCPCavvPurchase();

  mcpCavvPurchase.setOrderId(order_id);
  mcpCavvPurchase.setCustId(cust_id);
  mcpCavvPurchase.setAmount(amount);
  mcpCavvPurchase.setPan(pan);
  mcpCavvPurchase.setExpdate(expdate);
  mcpCavvPurchase.setCavv(cavv);
  mcpCavvPurchase.setCryptType(crypt_type); //Mandatory for AMEX only
  mcpCavvPurchase.setDynamicDescriptor(dynamic_descriptor);
  //mcpCavvPurchase.setWalletIndicator("APP"); //set only for wallet transactions. e.g APPLE PAY
  //mcpCavvPurchase.setNetwork("Interac"); //set only for Interac e-commerce
  //mcpCavvPurchase.setDataType("3DSecure"); //set only for Interac e-commerce
  //mcpCavvPurchase.setCmId("8nAK8712sGaAkls56"); //set only for usage with Offlinx - Unique
  max 50 alphanumeric characters transaction id generated by merchant
  
  mcpCavvPurchase.setThreeDSVersion("2"); //Mandatory for 3DS Version 2.0+
  mcpCavvPurchase.setThreeDSServerTransId("e11d4985-8d25-40ed-99d6-c3803fe5e68f"); //Mandatory
  for 3DS Version 2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
  //mcpCavvPurchase.setDsTransId("12345"); //Optional - to be used only if you are using 3rd
  party 3ds 2.0 service
  
  //MCP Fields
  mcpCavvPurchase.setMCPVersion("1.0");
  mcpCavvPurchase.setCardholderCurrencyCode("`}{this.getValue(currency, "currency")}{`");
  mcpCavvPurchase.setMCPRateToken("${mcpRateToken}");
  
  //optional - Credential on File details
  CofInfo cof = new CofInfo();
  cof.setPaymentIndicator("U");
  cof.setPaymentInformation("2");
  cof.setIssuerId("139X3130ASCXAS9");
  
  mcpCavvPurchase.setCofInfo(cof);

  HttpsPostRequest mpgReq = new HttpsPostRequest();

  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(mcpCavvPurchase);
  mpgReq.setStatusCheck(status_check);
  mpgReq.send();

  try
  { 
   Receipt receipt = mpgReq.getReceipt();
   System.out.println("CardType = " + receipt.getCardType());
   System.out.println("TransAmount = " + receipt.getTransAmount());
   System.out.println("TxnNumber = " + receipt.getTxnNumber());
   System.out.println("ReceiptId = " + receipt.getReceiptId());
   System.out.println("TransType = " + receipt.getTransType());
   System.out.println("ReferenceNum = " + receipt.getReferenceNum());
   System.out.println("ResponseCode = " + receipt.getResponseCode());
   System.out.println("ISO = " + receipt.getISO());
   System.out.println("BankTotals = " + receipt.getBankTotals());
   System.out.println("Message = " + receipt.getMessage());
   System.out.println("AuthCode = " + receipt.getAuthCode());
   System.out.println("Complete = " + receipt.getComplete());
   System.out.println("TransDate = " + receipt.getTransDate());
   System.out.println("TransTime = " + receipt.getTransTime());
   System.out.println("Ticket = " + receipt.getTicket());
   System.out.println("TimedOut = " + receipt.getTimedOut());
   System.out.println("CavvResultCode = " + receipt.getCavvResultCode());
   System.out.println("IssuerId = " + receipt.getIssuerId());
   System.out.println("ThreeDSVersion = " + receipt.getThreeDSVersion());

   System.out.println("MerchantSettlementAmount = " + receipt.getMerchantSettlementAmount());
   System.out.println("CardholderAmount = " + receipt.getCardholderAmount());
   System.out.println("CardholderCurrencyCode = " + receipt.getCardholderCurrencyCode());
   System.out.println("MCPRate = " + receipt.getMCPRate());
   System.out.println("MCPErrorStatusCode = " + receipt.getMCPErrorStatusCode());
   System.out.println("MCPErrorMessage = " + receipt.getMCPErrorMessage());
   System.out.println("HostId = " + receipt.getHostId());
  } 
  catch (Exception e)
  { 
   e.printStackTrace();
  }
 }
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken, expdate, amount, currency, pan, cavv, eci, mcpRateToken } = this.props;

        return (
            <pre className="sampleCode">
{`
<?php

## Example php -q TestPurchase-VBV.php "moneris" store
require "../../mpgClasses.php";

/******************************* Request Variables ********************************/
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';

/****************************** Transactional Variables ***************************/
$type='mcp_cavv_purchase';
$order_id='ord-'.date("dmy-G:i:s");
$cust_id='CUST887763';
$amount='`}{this.getValue(amount, "amount")}{`';
$pan="`}{this.getValue(pan, "pan")}{`";
$expdate='`}{this.getValue(expdate, "expdate")}{`';
$cavv='${cavv}';
$crypt_type = '${eci}';
$wallet_indicator = "APP";
$dynamic_descriptor='123456';
$mcp_version = '1.0';
$cardholder_amount = '100';
$cardholder_currency_code = '`}{this.getValue(currency, "currency")}{`';
$mcp_rate_token = '${mcpRateToken}';

/*************************** Transaction Associative Array ************************/
$txnArray=array(
'type'=>$type,
'order_id'=>$order_id,
'cust_id'=>$cust_id,
'amount'=>$amount,
'pan'=>$pan,
'expdate'=>$expiry_date,
'cavv'=>$cavv,
'crypt_type'=>$crypt_type, //mandatory for AMEX only
//'wallet_indicator'=>$wallet_indicator, //set only for wallet transactions. e.g. APPLE PAY
//'network'=> "Interac", //set only for Interac e-commerce
'data_type'=> "3DSecure", //set only for Interac e-commerce
'dynamic_descriptor'=>$dynamic_descriptor,
'threeds_version' => '2', //Mandatory for 3DS Version 2.0+
'threeds_server_trans_id' => 'e11d4985-8d25-40ed-99d6-c3803fe5e68f', //Mandatory for 3DS
Version 2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
//'cm_id' => '8nAK8712sGaAkls56', //set only for usage with Offlinx - Unique max 50
alphanumeric characters transaction id generated by merchant
//'ds_trans_id' => '12345', //Optional - to be used only if you are using 3rd party 3ds 2.0
service
'mcp_version'=> $mcp_version,
'cardholder_amount' => $cardholder_amount,
'cardholder_currency_code' => $cardholder_currency_code,
'mcp_rate_token' => $mcp_rate_token
);

/****************************** Transaction Object *******************************/
$mpgTxn = new mpgTransaction($txnArray);

/******************* Credential on File **********************************/
$cof = new CofInfo();
$cof->setPaymentIndicator("U");
$cof->setPaymentInformation("2");
$cof->setIssuerId("139X3130ASCXAS9");
$mpgTxn->setCofInfo($cof);

/******************************* Request Object **********************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions

/****************************** HTTPS Post Object *******************************/
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest);

/************************************* Response *********************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nCardType = " . $mpgResponse->getCardType());
print("\\nTransAmount = " . $mpgResponse->getTransAmount());
print("\\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nTransType = " . $mpgResponse->getTransType());
print("\\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nISO = " . $mpgResponse->getISO());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nAuthCode = " . $mpgResponse->getAuthCode());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTicket = " . $mpgResponse->getTicket());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nCavvResultCode = " . $mpgResponse->getCavvResultCode());
print("\\nIssuerId = " . $mpgResponse->getIssuerId());
print("\\nThreeDSVersion = " . $mpgResponse->getThreeDSVersion());
print("\\nMerchantSettlementAmount = " . $mpgResponse->getMerchantSettlementAmount());
print("\\nCardholderAmount = " . $mpgResponse->getCardholderAmount());
print("\\nCardholderCurrencyCode = " . $mpgResponse->getCardholderCurrencyCode());
print("\\nMCPRate = " . $mpgResponse->getMCPRate());
print("\\nMCPErrorStatusCode = " . $mpgResponse->getMCPErrorStatusCode());
print("\\nMCPErrorMessage = " . $mpgResponse->getMCPErrorMessage());
print("\\nHostId = " . $mpgResponse->getHostId());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, orderId, pan, expdate, amount, currency, onEditId, cavv, eci, mcpRateToken } = state.mcp.main.config;
    const { selection } = state.common.progLangList;
    return { storeId, apiToken, orderId, pan, expdate, amount, currency, progLangId: selection, onEditId, cavv, eci, mcpRateToken };
  }
  
  export default connect(mapStateToProps, {})(PurchaseWith3DSSample)